// Make this look similar to the Sitecore deployment during local development
// so that we can hardcode this relative path in our application and it will work
// both locally, in UAT, and in production.
export const outputPath = '/spContent/dvl/netzero-v2/';
